module.exports = __webpack_public_path__ + "fonts/b1721311-de06-4277-8dcb-bf39e072b75e.303331ed.eot";